import { Injectable } from "@angular/core";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { PermissionTypeDto } from "clearline-api";

@Injectable({
  providedIn: "root"
})
export class TooltipManagerService {
  private activeTooltip: NgbTooltip | null = null;
  private lockedTooltipContentsMap = new Map<PermissionTypeDto, string>();
  private infoTooltipContentsMap = new Map<PermissionTypeDto, string>();

  /** Tracks whether a tooltip is currently open — used to keep sidebar expanded */
  private _tooltipOpen = false;

  getLockedTooltipContent(targetFeature: PermissionTypeDto): string {
    return this.lockedTooltipContentsMap.get(targetFeature) || "";
  }

  registerLockedTooltipContent(feature: PermissionTypeDto, content: string): void {
    this.lockedTooltipContentsMap.set(feature, content);
  }

  getInfoTooltipContent(targetFeature: PermissionTypeDto): string {
    return this.infoTooltipContentsMap.get(targetFeature) || "";
  }

  registerInfoTooltipContent(feature: PermissionTypeDto, content: string): void {
    this.infoTooltipContentsMap.set(feature, content);
  }

  hasInfoTooltip(targetFeature: PermissionTypeDto): boolean {
    return this.infoTooltipContentsMap.has(targetFeature);
  }

  registerTooltip(tooltip: NgbTooltip): void {
    if (this.activeTooltip && this.activeTooltip !== tooltip) {
      this.activeTooltip.close();
    }
    this.activeTooltip = tooltip;
    this._tooltipOpen = true;
    document.body.classList.add("sidebar-tooltip-active");
  }

  closeActiveTooltip(): void {
    if (this.activeTooltip) {
      this.activeTooltip.close();
      this.activeTooltip = null;
    }
    this._tooltipOpen = false;
    this.removeSidebarTooltipClasses();
  }

  /** Detach tooltip without removing sidebar classes — used when mouse goes to sidebar */
  detachTooltip(): void {
    this.activeTooltip = null;
    this._tooltipOpen = false;
    document.body.classList.remove("sidebar-tooltip-active");
    // Don't remove sidebar-logo-expanded — sidebar :hover will handle it
  }

  clearTooltip(tooltip: NgbTooltip): void {
    if (this.activeTooltip === tooltip) {
      this.activeTooltip = null;
      this._tooltipOpen = false;
      this.removeSidebarTooltipClasses();
    }
  }

  private removeSidebarTooltipClasses(): void {
    document.body.classList.remove("sidebar-tooltip-active");
    // If mouse is not on the sidebar, also remove logo class
    const sidebarHovered = document.querySelector(".vertical-menu:hover");
    if (!sidebarHovered) {
      document.body.classList.remove("sidebar-logo-expanded");
    }
  }
}
